import { register } from '../../../JavaScript/Utils'

declare global {
  interface Window {
    Splide?: Splide
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any

export const BannerSliderText = (el: HTMLElement) => {
  const init = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.splide-wrapper')

    const bannerSliderText = new Splide(sliderContainer, {
      type: 'loop',
      pagination: false,
      perPage: 1,
      perMove: 1,
    })

    bannerSliderText.mount()
  }

  init()
}

register('BannerSliderText', BannerSliderText)
